import { render, staticRenderFns } from "./ManutencaoModal.vue?vue&type=template&id=40e608a6&scoped=true"
import script from "./ManutencaoModal.vue?vue&type=script&lang=js"
export * from "./ManutencaoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e608a6",
  null
  
)

export default component.exports